import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('Abstraction over global window object', {
  factory: () => {
    const { defaultView } = inject(DOCUMENT);

    if (!defaultView) {
      throw new Error('Window is not available');
    }

    return defaultView;
  }
});

export const LOCAL_STORAGE = new InjectionToken<Storage>('Abstraction over window.localStorage object', {
  factory: () => inject(WINDOW).localStorage
});

export const SESSION_STORAGE = new InjectionToken<Storage>('Abstraction over window.sessionStorage object', {
  factory: () => inject(WINDOW).sessionStorage
});
